import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle, faEnvelopeOpen } from '@fortawesome/free-solid-svg-icons'
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons'

const SubmitMessage = () => {
    return(
        <div className="alertContact">
            <span> <FontAwesomeIcon className="icon" icon={faExclamationCircle} /> </span>
            <p>Ha ocurrido un error, pero aún puedes comunicarte conmigo desde mis redes sociales.</p>
            <p>Contacto: Mauuroaraujo@gmail.com</p>
        </div>
    )
}

const TextError = ({ error }) => {
    return (
        <p className="texterror">{error}</p>
    )
}

const Contact = () => {

        const [submitOn, setSubmitOn] = useState('no enviado')

        const handleFormVerify = (e) => {
            e.preventDefault()

            if(e.target.name.value === '' || e.target.email.value === '' || e.target.message.value === ''){
               setSubmitOn('error')
            }else {
                setSubmitOn('enviado')
            }
        }

        return(
            <section className='contact'>
                <h2 data-aos="fade-up" id="contact" className="title">Contactame</h2>

                <div data-aos="fade-up" className="socialIcons">
                    <a target="_blank" rel="noopener noreferrer" href="http://github.com/mawaraujo">
                        <FontAwesomeIcon className="icons" icon={faGithub} />
                    </a>

                    <a target="_blank" rel="noopener noreferrer" href="https://linkedin.com/in/mawaraujo">
                        <FontAwesomeIcon className="icons mr-2" icon={faLinkedin} />
                    </a>

                    <a href="mailto:mauuroaraujo@gmail.com">
                        <FontAwesomeIcon className="icons" icon={faEnvelopeOpen} />
                    </a>
                </div>

                <article data-aos="fade-up" className="contact-content">
                    <div className="contact-card">

                        {submitOn !== 'enviado' ? 
                            <form onSubmit={handleFormVerify}>

                                <div className="form-pack">
                                    <label htmlFor="name">Nombre y apellido</label>
                                    <input placeholder="Jhon Webly" type="text" name="name" id="name" />
                                </div>

                                <div className="form-pack">
                                    <label htmlFor="email">Correo electrónico</label>
                                    <input placeholder="Maw@example.com" type="email" name="email" id="email"/>
                                </div>

                                <div className="form-pack">
                                    <label htmlFor="message">Mensaje</label>
                                    <textarea placeholder="Your message" name="message" id="message" cols="30" rows="6"></textarea>
                                </div> 

                                { submitOn === 'error' 
                                    ? <TextError error="Los campos no deben estár vacios." /> 
                                    : undefined 
                                }

                                <div className="form-pack">
                                    <input className="btn btn-primary" type="submit" value="Enviar mensaje"/>
                                </div>

                            </form>

                            : <SubmitMessage />
                        }
                        
                    </div>
                </article>
            </section>
        )
}

export default Contact